import styled from 'styled-components';

export const RoundedButton = styled.button`
  border: none;
  cursor: pointer;
  color: white;
  min-height: 32px;
  background: #5c8df3 ;
  position: relative;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  
  &:hover:after {
    content: '';
    background: rgba(0,0,0,0.1);
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  
  &:focus {
    outline: 0;
  }
`;

export const ButtonIcon = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0;
  padding: 0 8px;
`;

export const ButtonLabel = styled.div`
  flex: 1 1;
`;
